<template>
	<div class="container-fluid ninjas-page">
		<!-- home -->
		<template v-for="section in templateData.landing_page_sections">
			<div
				v-if="section.position == 'top'"
				id="hero"
				:key="'section-' + section.id"
				:style="{ backgroundImage: 'url(' + section.background_url + ')' }"
				class="row section-global pos-r section-block"
			>
				<div class="static-pages">
					<div class="static-pages-title">
						<div class="container">
							<div class="content-holder">
								<div
									class="intro-image"
									:style="{ order: +section.reverse_order ? 1 : 0 }"
								>
									<img :src="section.logo_url" class="img-response-w" >
								</div>
								<div
									class="text-wrapper-mid"
									:style="{ order: +section.reverse_order ? 0 : 1 }"
								>
									<img
										v-if="section.mini_logo_url"
										:src="section.mini_logo_url"
										class="p-b"
										width="280"
									>
									<h1 class="text-white text-upper" v-html="section.title"/>
									<h3
										class="text-white m-t-lg ql-editor"
										v-html="section.body"
									/>
									<div v-html="section.klaviyo_embed" />
									<div class="btn-brothers">
										<template v-for="button in section.landing_page_buttons">
											<a
												v-if="button.type == 1"
												:key="'button-' + button.id"
												:href="button.url"
												target="_blank"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green"
											>
												{{ button.text }}
											</a>
											<a
												v-if="button.type == 2"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												@click="scrollToDiv('#influencer-pc')"
											>
												{{ button.text }}
											</a>
											<button
												v-if="button.type == 3"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												@click="openVideoModal(button.url)"
											>
												{{ button.text }}
											</button>
											<a
												v-if="button.type == 4"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												@click.prevent="sendToConfigurator(button.url, true)"
											>
												{{ button.text }}
											</a>
										</template>
									</div>
									<!-- social -->
									<div v-if="section.has_social_links == 1" class="social-follow">
										<h3 class="text-white">
											Follow {{ templateData.influencer_name }}:
										</h3>
										<a
											v-if="templateData.twitch"
											:href="templateData.twitch"
											target="_blank"
										>
											<img
												src="/images/brand-logos/twitch.svg"
												alt="TwitchTV"
												width="79"
											>
										</a>
										<a
											v-if="templateData.mixer_url"
											:href="templateData.mixer_url"
											target="_blank"
										>
											<img src="/images/brand-logos/mixer.svg" alt="Mixer" >
										</a>
										<a
											v-if="templateData.youtube"
											:href="templateData.youtube"
											target="_blank"
										>
											<img
												src="/images/brand-logos/youtube.svg"
												alt="YouTube"
												width="79"
											>
										</a>
										<a
											v-if="templateData.twitter"
											:href="templateData.twitter"
											target="_blank"
										>
											<img
												src="/images/logos/twitter.svg"
												alt="Twitter"
												width="79"
											>
										</a>
									</div>
									<!-- /.social -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<!-- /.home -->
		<!-- bld-by-experts -->
		<div
			v-if="templateData.landing_page_builds.length"
			id="influencer-pc"
			class="row pos-r bg-white"
		>
			<div class="col-xs-12 p-a-0">
				<div class="container-fluid">
					<div class="row m-b-lg">
						<div class="visible-lg visible-md visible-sm">
							<!-- tabs -->
							<ul
								:class="templateData.tab_style"
								class="nav nav-tabs text-center bg-black m-b-md"
								role="tablist"
							>
								<li
									v-for="(build, index) in templateData.landing_page_builds"
									:key="'build-tab-' + index"
									:class="{ active: index == 0 }"
								>
									<a
										:href="'#' + build.bld_number"
										:style="
											templateData.tab_style == 'promo'
												? {
													backgroundColor: build.bg_color,
													color: build.text_color
												}
												: ''
										"
										aria-controls="bld-max"
										class="bld-max text-bold"
										data-toggle="tab"
										role="tab"
										aria-expanded="true"
										@click="selectedBuildId = build.bld_number"
									>
										<img
											v-if="build.tab_icon"
											:src="build.tab_icon"
											class="tab-icon"
										>
										<span class="build-title">{{ build.title }}</span>
									</a>
								</li>
							</ul>
							<!-- /.tabs -->
							<!-- expert-content -->
							<div class="tab-content">
								<!-- ninjas -->
								<div
									v-for="(build, index) in templateData.landing_page_builds"
									v-show="selectedBuildId == build.bld_number"
									id="bld-max"
									:key="'build-detail-' + index"
									:class="{ active: selectedBuildId == build.bld_number }"
									role="tab-panel"
									class="tab-pane"
								>
									<div class="container section-global">
										<div class="intro-image">
											<img :src="build.image_url" class="img-response-w" >
										</div>
										<div class="text-wrapper-mid">
											<div class="influencer-build">
												<div class="content-title-holder">
													<h2 class="text-upper m-a-0">{{ build.label }}</h2>
													<p class="text-green">
														${{ build.price | priceFormat }}
													</p>
												</div>
												<template v-if="+templateData.show_games">
													<div
														v-for="game in build.performance"
														:key="
															'build-games-' + build.bld_number + '-' + game.id
														"
														class="game-render-fps"
													>
														<div class="game-img pull-left">
															<img
																:src="game.images"
																:alt="game.name"
																class="img-response-w"
															>
														</div>
														<div class="game-desc pull-left">
															<p class="game-title">{{ game.name }}</p>
															<p class="game-fps">{{ game.game_value }}fps</p>
														</div>
													</div>
												</template>
											</div>
											<div class="row influencer-pc-specs m-t-md">
												<div class="col-xs-12 col-sm-6">
													<ol class="list-none">
														<li
															v-for="(special, specialIndex) in build.products
																.specials"
															:key="'special-' + build.bld_number + '-' + specialIndex"
															class="text-upper text-bold special-product"
														>
															{{ special.name }}
														</li>
														<li class="text-upper text-bold">
															{{ build.products.cases.name }}
															<span class="text-sm text-normal">CASE</span>
														</li>
														<li class="text-upper text-bold">
															{{ build.products.motherboards.name }}
															<span class="text-sm text-normal">MOBO</span>
														</li>
														<li class="text-upper text-bold">
															{{ build.products.cpus.name }}
															<span class="text-sm text-normal">CPU</span>
														</li>
														<li class="text-upper text-bold">
															{{ build.products.coolers.name }}
															<span class="text-sm text-normal">
																CPU COOLER
															</span>
														</li>
														<li class="text-upper text-bold">
															{{ build.products.gpus.name }}
															<span class="text-sm text-normal">GPU</span>
														</li>
														<li class="text-upper text-bold">
															{{ build.products.ram.name }}
															<span class="text-sm text-normal">RAM</span>
														</li>
													</ol>
												</div>

												<div class="col-xs-12 col-sm-6">
													<ol class="list-none">
														<li
															v-for="(disk, ssdIndex) in build.products.ssd"
															:key="'ssd-' + build.bld_number + '-' + ssdIndex"
															class="text-upper text-bold"
														>
															{{ disk.name }}
															{{ disk.capacity }}
															<template v-if="disk.quantity > 1">
																({{ disk.quantity }})
															</template>
															<span class="text-sm text-normal">SSD</span>
														</li>
														<li
															v-for="(disk, hddIndex) in build.products.hdd"
															:key="'hdd-' + build.bld_number + '-' + hddIndex"
															class="text-upper text-bold"
														>
															{{ disk.name }}
															{{ disk.capacity }}
															<template v-if="disk.quantity > 1">
																({{ disk.quantity }})
															</template>
															<span class="text-sm text-normal">HDD</span>
														</li>
														<li class="text-upper text-bold">
															{{ build.products.psus.name }}
															<span class="text-sm text-normal">PSU</span>
														</li>
														<li
															v-for="(fan, fansIndex) in build.products.fans"
															:key="'fans-' + build.bld_number + '-' + fansIndex"
															class="text-upper text-bold"
														>
															{{ fan.name }}
															<template v-if="fan.quantity > 1">
																({{ fan.quantity }})
															</template>
															<span class="text-sm text-normal">FAN</span>
														</li>
														<li
															v-for="(extra, extrasIndex) in build.products.extras"
															:key="'extras-' + build.bld_number + '-' + extrasIndex"
															class="text-upper text-bold"
														>
															{{ extra.name }}
															<span class="text-sm text-normal">EXTRA</span>
														</li>
														<li
															v-for="(peripheral, peripheralIndex) in build.products
																.peripherals"
															:key="
																'peripherals-' + build.bld_number + '-' + peripheralIndex
															"
															class="text-upper text-bold"
														>
															{{ peripheral.name }}
															<span class="text-sm text-normal">
																PERIPHERAL
															</span>
														</li>
														<li
															v-for="(monitor, monitorIndex) in build.products
																.monitors"
															:key="
																'monitors-' + build.bld_number + '-' + monitorIndex
															"
															class="text-upper text-bold"
														>
															{{ monitor.name }}
															<template v-if="monitor.quantity > 1">
																({{ monitor.quantity }})
															</template>
															<span class="text-sm text-normal">MONITOR</span>
														</li>
													</ol>
												</div>
											</div>
											<template v-if="Number(build.show_action_buttons)">
												<div class="btn-brothers">
													<a
														href="#"
														class="btn btn-green m-y-md"
														@click.prevent="
															sendToConfigurator(build.bld_number, true)
														"
													>
														GET THIS BLD
													</a>
													<a
														href="#"
														class="btn btn-green btn-outline m-y-md"
														@click.prevent="
															sendToConfigurator(build.bld_number)
														"
													>
														CUSTOMIZE BUILD
													</a>
												</div>
											</template>
										</div>
									</div>
								</div>
								<!-- ninjas -->
							</div>
						</div>
						<div class="visible-xs pos-r front">
							<ul
								id="price-tabs"
								:class="templateData.tab_style"
								class="nav nav-tabs text-center bg-black m-b-md front"
								role="tablist"
							>
								<li
									v-for="(build, index) in templateData.landing_page_builds"
									:key="'build-mobile-' + index"
									:class="{ active: selectedBuildId == build.bld_number }"
									:id="{ ninjaOp: index == 0 }"
								>
									<a
										:class="{ bldMax: index == 0, bldMedium: index != 0 }"
										:style="
											templateData.tab_style == 'promo'
												? {
													backgroundColor: build.bg_color,
													color: build.text_color
												}
												: ''
										"
										href="#"
										class="text-bold"
										aria-controls="bld-max-mobile"
										data-toggle="tab"
										role="tab"
										aria-expanded="true"
										@click="selectedBuildId = build.bld_number"
									>
										<img
											v-if="build.tab_icon"
											:src="build.tab_icon"
											class="tab-icon"
										>
										<span class="build-title">{{ build.title }}</span>
									</a>
								</li>
							</ul>
							<div class="tab-content">
								<!-- ninjas -->
								<div
									v-for="(build, bIdx) in templateData.landing_page_builds"
									v-show="selectedBuildId == build.bld_number"
									:key="'build-detail-mobile-' + bIdx"
									:id="build.bld_number"
									role="tab-panel"
									class="tab-pane active expert-content-holder"
								>
									<div class="container p-a-0">
										<div class="influencer-build">
											<div class="content-title-holder">
												<h2 class="text-upper m-a-0">{{ build.label }}</h2>
												<p class="text-green">
													${{ build.price | priceFormat }}
												</p>
											</div>
											<template v-if="+templateData.show_games">
												<div
													v-for="game in build.performance"
													:key="
														'build-games-mobile-' +
															build.bld_number +
															'-' +
															game.id
													"
													class="game-render-fps"
												>
													<div class="game-img pull-left">
														<img :src="game.images" class="img-response-w" >
													</div>
													<div class="game-desc pull-left">
														<p class="game-title">{{ game.name }}</p>
														<p class="game-fps">{{ game.game_value }}fps</p>
													</div>
												</div>
											</template>
										</div>
										<div class="intro-image">
											<img :src="build.image_url" class="img-response-w" >
										</div>
										<div class="row influencer-pc-specs m-t-md">
											<div class="col-xs-12 col-sm-6">
												<ol class="list-none">
													<li
														v-for="(special, index) in build.products.specials"
														:key="'special-' + build.bld_number + '-' + index"
														class="text-upper text-bold special-product"
													>
														{{ special.name }}
													</li>
													<li class="text-upper text-bold">
														{{ build.products.cases.name }}
														<span class="text-sm text-normal">CASE</span>
													</li>
													<li class="text-upper text-bold">
														{{ build.products.motherboards.name }}
														<span class="text-sm text-normal">MOBO</span>
													</li>
													<li class="text-upper text-bold">
														{{ build.products.cpus.name }}
														<span class="text-sm text-normal">CPU</span>
													</li>
													<li class="text-upper text-bold">
														{{ build.products.coolers.name }}
														<span class="text-sm text-normal">CPU COOLER</span>
													</li>
													<li class="text-upper text-bold">
														{{ build.products.gpus.name }}
														<span class="text-sm text-normal">GPU</span>
													</li>
													<li class="text-upper text-bold">
														{{ build.products.ram.name }}
														<span class="text-sm text-normal">RAM</span>
													</li>
												</ol>
											</div>

											<div class="col-xs-12 col-sm-6">
												<ol class="list-none">
													<li
														v-for="(disk, index) in build.products.ssd"
														:key="
															'ssd-mobile-' + build.bld_number + '-' + index
														"
														class="text-upper text-bold"
													>
														{{ disk.name }}
														<template v-if="disk.quantity > 1">
															({{ disk.quantity }})
														</template>
														<span class="text-sm text-normal">SSD</span>
													</li>
													<li
														v-for="(disk, index) in build.products.hdd"
														:key="
															'hdd-mobile-' + build.bld_number + '-' + index
														"
														class="text-upper text-bold"
													>
														{{ disk.name }}
														<template v-if="disk.quantity > 1">
															({{ disk.quantity }})
														</template>
														<span class="text-sm text-normal">HDD</span>
													</li>
													<li class="text-upper text-bold">
														{{ build.products.psus.name }}
														<span class="text-sm text-normal">PSU</span>
													</li>
													<li
														v-for="(fan, index) in build.products.fans"
														:key="
															'fans-mobile-' + build.bld_number + '-' + index
														"
														class="text-upper text-bold"
													>
														{{ fan.name }}
														<template v-if="fan.quantity > 1">
															({{ fan.quantity }})
														</template>
														<span class="text-sm text-normal">FAN</span>
													</li>
													<li
														v-for="(extra, index) in build.products.extras"
														:key="
															'extras-mobile-' + build.bld_number + '-' + index
														"
														class="text-upper text-bold"
													>
														{{ extra.name }}
														<span class="text-sm text-normal">EXTRA</span>
													</li>
													<li
														v-for="(peripheral, index) in build.products
															.peripherals"
														:key="
															'peripherals-mobile-' +
																build.bld_number +
																'-' +
																index
														"
														class="text-upper text-bold"
													>
														{{ peripheral.name }}
														<span class="text-sm text-normal">PERIPHERAL</span>
													</li>
													<li
														v-for="(monitor, index) in build.products.monitors"
														:key="
															'monitors-mobile-' +
																build.bld_number +
																'-' +
																index
														"
														class="text-upper text-bold"
													>
														{{ monitor.name }}
														<template v-if="monitor.quantity > 1">
															({{ monitor.quantity }})
														</template>
														<span class="text-sm text-normal">MONITOR</span>
													</li>
												</ol>
											</div>
										</div>
										<template v-if="Number(build.show_action_buttons)">
											<a
												href="#"
												class="btn btn-green m-y-md"
												@click.prevent="
													sendToConfigurator(build.bld_number, true)
												"
											>
												GET THIS BLD
											</a>
											<a
												href="#"
												class="btn btn-green btn-outline match m-y-md"
												@click.prevent="sendToConfigurator(build.bld_number)"
											>
												CUSTOMIZE BUILD
											</a>
										</template>
									</div>
								</div>
								<!-- ninjas -->
							</div>
						</div>
						<!-- /.expert-content -->
					</div>
				</div>
			</div>
		</div>
		<!-- /.bld-by-experts -->
		<!-- bld-by-experts -->
		<div
			v-if="templateData.gleam_embed"
			id="promo-section"
			class="row pos-r bg-white pos-r front p-t-lg gleam-overlay"
		>
			<div class="col-xs-12 p-a-0">
				<div class="container-fluid">
					<div class="row m-b-lg">
						<div
							class="gleam-iframe text-center"
							v-html="templateData.gleam_embed"
						/>
					</div>
				</div>
			</div>
		</div>
		<!-- /.bld-by-experts -->
		<!-- service-package -->
		<div id="home-service" class="service-package row">
			<div>
				<div class="bld-features col-xs-12 p-a-0 m-y">
					<div class="service-details col-xs-12 col-md-3 text-center m-y">
						<div class="img-container">
							<img src="/images/icons/build-ico.png" class="m-auto" >
						</div>
						<div class="content">
							<div class="text-white text-upper">
								<h3 class="text-bold">TAILORED FOR<br >GAMES</h3>
							</div>
							<div class="text text-white">
								<p class="text-bold">
									We’ve done the research and our algorithm takes care of the
									rest.
								</p>
							</div>
						</div>
						<router-link to="/what-is-bld" class="link-btn link-white">
							LEARN MORE
							<i class="fa fa-chevron-right" aria-hidden="true" />
						</router-link>
					</div>
					<div class="service-details col-xs-12 col-md-3 text-center m-y">
						<div class="img-container">
							<img src="/images/icons/glass.png" class="m-auto" >
						</div>
						<div class="content">
							<div class="text-white text-upper">
								<h3 class="text-bold">TRANSPARENT<br >PRICING</h3>
							</div>
							<div class="text text-white">
								<p class="text-bold">
									Customize your build with our curated parts with straight
									forward pricing and a flat $99 assembly fee.
								</p>
							</div>
						</div>
						<router-link to="/what-is-bld" class="link-btn link-white">
							LEARN MORE
							<i class="fa fa-chevron-right" aria-hidden="true" />
						</router-link>
					</div>
					<div class="service-details col-xs-12 col-md-3 text-center m-y">
						<div class="img-container">
							<img src="/images/icons/2year-ico.png" class="m-auto" >
						</div>
						<div class="content">
							<div class="text-white text-upper">
								<h3 class="text-bold">All-in-One<br >Warranty</h3>
							</div>
							<div class="text text-white">
								<p class="text-bold">
									All components under one warranty plan – NZXT will manage any
									problems for you.
								</p>
							</div>
						</div>
						<router-link to="/what-is-bld" class="link-btn link-white">
							LEARN MORE
							<i class="fa fa-chevron-right" aria-hidden="true" />
						</router-link>
					</div>
					<div class="service-details col-xs-12 col-md-3 text-center m-y">
						<div class="img-container">
							<img src="/images/icons/shipping-ico.png" class="m-auto" >
						</div>
						<div class="content">
							<div class="text-white text-upper">
								<h3 class="text-bold">48-Hour<br >Turnaround</h3>
							</div>
							<div class="text text-white">
								<p class="text-bold">
									Get in the game quickly.
								</p>
							</div>
						</div>
						<router-link to="/what-is-bld" class="link-btn link-white">
							LEARN MORE
							<i class="fa fa-chevron-right" aria-hidden="true" />
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<template v-for="section in templateData.landing_page_sections">
			<div
				v-if="section.position == 'bottom'"
				id="hero"
				:key="'section-' + section.id"
				:style="{ backgroundImage: 'url(' + section.background_url + ')' }"
				class="row section-global pos-r section-block"
			>
				<div class="static-pages">
					<div class="static-pages-title">
						<div class="container">
							<div class="content-holder">
								<div
									class="intro-image"
									:style="{ order: +section.reverse_order ? 1 : 0 }"
								>
									<img :src="section.logo_url" class="img-response-w" >
								</div>
								<div
									class="text-wrapper-mid"
									:style="{ order: +section.reverse_order ? 0 : 1 }"
								>
									<img
										v-if="section.mini_logo_url"
										:src="section.mini_logo_url"
										class="p-b"
										width="300"
									>
									<h1 class="text-white text-upper" v-html="section.title"/>
									<h3
										class="text-white m-t-lg ql-editor"
										v-html="section.body"
									/>
									<div v-html="section.klaviyo_embed" />
									<div class="btn-brothers">
										<template v-for="button in section.landing_page_buttons">
											<a
												v-if="button.type == 1"
												:key="'button-' + button.id"
												:href="button.url"
												target="_blank"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green"
											>
												{{ button.text }}
											</a>
											<a
												v-if="button.type == 2"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												@click="scrollToDiv('#influencer-pc')"
											>
												{{ button.text }}
											</a>
											<button
												v-if="button.type == 3"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												@click="openVideoModal(button.url)"
											>
												{{ button.text }}
											</button>
											<a
												v-if="button.type == 4"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												@click.prevent="sendToConfigurator(button.url, true)"
											>
												{{ button.text }}
											</a>
										</template>
									</div>
									<!-- social -->
									<div v-if="section.has_social_links == 1" class="social-follow">
										<h3 class="text-white">
											Follow {{ templateData.influencer_name }}:
										</h3>
										<a
											v-if="templateData.twitch"
											:href="templateData.twitch"
											target="_blank"
										>
											<img
												src="/images/brand-logos/twitch.svg"
												alt="TwitchTV"
												width="79"
											>
										</a>
										<a
											v-if="templateData.youtube"
											:href="templateData.youtube"
											target="_blank"
										>
											<img
												src="/images/brand-logos/youtube.svg"
												alt="YouTube"
												width="79"
											>
										</a>
										<a
											v-if="templateData.twitter"
											:href="templateData.twitter"
											target="_blank"
										>
											<img
												src="/images/logos/twitter.svg"
												alt="Twitter"
												width="79"
											>
										</a>
									</div>
									<!-- /.social -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>

		<!-- /.service-package -->
		<!-- bld-intro-text -->
		<div id="what-is-bld" class="row pos-r bg-black">
			<template v-for="section in templateData.landing_page_sections">
				<a
					v-if="['mini-left', 'mini-right'].includes(section.position)"
					:key="'section-' + section.id"
					:href="section.landing_page_buttons[0].url"
					:style="{ backgroundImage: 'url(' + section.background_url + ')' }"
					class="home-card bg-nzxt-section col-xs-12 col-md-6 p-a-0 pos-r section-block"
					target="_blank"
				>
					<div class="section-content-holder p-y-md p-x m-auto text-white front">
						<div class="content-title-holder">
							<h2 class="text-upper">{{ section.title | stripTags }}</h2>
							<template v-for="button in section.landing_page_buttons">
								<a
									v-if="button.type == 1"
									:key="'btn-' + button.id"
									:href="button.url"
									class="link-btn link-white"
									target="_blank"
								>
									{{ button.text | upperCase }}
									<i class="fa fa-chevron-right" />
								</a>
							</template>
						</div>
						<img :src="section.logo_url" class="img-response-w" >
						<div class="clearfix" />
					</div>
				</a>
			</template>
		</div>
		<!-- /.bld-intro-text -->
		<div
			v-if="showVideoModal"
			id="video-modal"
			class="modal fade bs-example-modal-lg"
			tabindex="-1"
			role="dialog"
			aria-labelledby="myLargeModalLabel"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<iframe
						:src="youtubeVideoLink"
						width="100%"
						height="500"
						frameborder="0"
						allow="autoplay; encrypted-media"
						allowfullscreen
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { isMobile } from "../../util/helpers";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

export default {
	name: "LandingPageTemplate",
	filters: {
		priceFormat(value) {
			if (!value) {
				return 0;
			}

			return Number(Number(value).toFixed(2)).toLocaleString("en");
		},
		upperCase: function(value) {
			if (!value) {
				return "";
			}

			return value.toString().toUpperCase();
		}
	},
	data() {
		return {
			fixPriceBar: "",
			influencerName: "",
			selectedBuildId: 0,
			showVideoModal: true,
			slickConfig: {
				dots: false,
				arrows: false,
				infinite: true,
				autoplay: true,
				speed: 300,
				slidesToShow: 4,
				slidesToScroll: 1,
				autoplaySpeed: 4000,
				responsive: [
					{
						breakpoint: 1366,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							infinite: true
						}
					},
					{
						breakpoint: 770,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			},
			templateData: {
				landing_page_builds: []
			},
			youtubeVideoLink: ""
		};
	},
	mounted() {
		this.influencerName = "ninja";
		this.getTemplateData();
		$("#video-modal").on("hidden.bs.modal", () => {
			this.youtubeVideoLink = "";
		});

		if (this.influencerName == "discord" && !Cookies.get("promos-discord")) {
			const offset = new Date().getTimezoneOffset() / 60;
			const expires = moment("2019-02-22 23:00:00")
				.subtract(offset, "hours")
				.toDate();
			Cookies.set("promos-discord", "1", { expires });
		}
	},
	methods: {
		getTemplateData() {
			axios({
				url: `/public-landing-pages/${this.influencerName}`
			})
				.then(response => {
					this.templateData = response.data;
					this.selectedBuildId = this.templateData.landing_page_builds[0].bld_number;
					this.setButtonRules();
				})
				.catch(error => {})
				.then(() => {
					this.initializeSlickGallery();
				});
		},
		initializeSlickGallery() {
			$(".bld-features").slick(
				Object.assign(this.slickConfig, {
					dots: true
				})
			);
		},
		sendToConfigurator(bldNumber, checkout = false) {
			axios({
				url: `/drafts/${bldNumber}/influencer`,
				method: "POST"
			}).then(response => {
				let step = isMobile() ? "step4-mobile" : "step4";

				if (checkout) {
					step = "step5";
				}

				this.$router.push({
					name: step,
					query: {
						price: 1000,
						draft: response.data
					}
				});
			});
		},
		setButtonRules() {
			const style = document.createElement("style");
			style.type = "text/css";
			document.querySelector("head").appendChild(style);

			this.templateData.landing_page_sections.forEach(section => {
				section.landing_page_buttons.forEach(button => {
					style.sheet.insertRule(
						`.btn-section-${section.id}-${button.id} { background-color: ${button.bg_color[0]}; color: ${button.text_color[0]}; border-color: ${button.bg_color[0]}; }`
					);
					style.sheet.insertRule(
						`.btn-section-${section.id}-${button.id}:hover { background-color: ${button.bg_color[1]}; color: ${button.text_color[1]}; border-color: ${button.bg_color[0]}; }`
					);
				});
			});
		},
		scrollToDiv(divId) {
			$("html,body").animate(
				{
					scrollTop: $(divId).offset().top - 50
				},
				1000
			);
		},
		openVideoModal(videoLink) {
			this.youtubeVideoLink = videoLink;
			$("#video-modal").modal("toggle");
		}
	}
};
</script>

<style lang="scss" scoped>
.section-block {
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
}

.overview-overlay .fps-graphing {
	display: flex;
	justify-content: center;
	align-items: flex-start;
	flex-wrap: wrap;
}

.overview-overlay .fps-graphing .fps-graphing-item {
	width: calc(100% / 3);
	text-align: center;
	margin-bottom: 0;
}

.text-white.screen-resolution-text {
	margin: 0;
}

.overview-overlay .fps-graphing .fps-graphing-item .vsync {
	font-size: 14px;
	font-family: "Akkurat-Normal";
}

.btn.btn-green.btn-outline.match.m-y-md {
	margin-top: 0 !important;
	margin-bottom: 0 !important;
}

#influencer-pc .expert-content-holder {
	margin-bottom: 0;
}

.special-product {
	color: #3adec0;
}

#influencer-pc ul.nav-tabs {
	span {
		vertical-align: middle;
	}

	li {
		img {
			height: 49px;
			width: 49px;
		}
	}

	&.promo {
		border-top: none;

		li {
			a {
				padding: 6px 15px;
			}

			img {
				margin: 13px 13px 13px 0;
			}

			&.active {
				margin-top: -23px;

				a {
					padding: 18px 15px 17px 15px;
				}
			}
		}
	}
}
@media screen and (max-width: 570px) and (min-width: 320px) {
	.ql-editor {
		.ql-size-huge {
			font-size: 1.5em !important;
		}
		.ql-size-large {
			font-size: 1em !important;
		}
	}

	#influencer-pc ul.nav-tabs {
		&.promo {
			li {
				a {
					.build-title {
						display: none;
					}
				}

				img {
					margin: 10px auto;
				}
			}
		}
	}
}

.ninjas-page {
	h1.text-white.text-upper {
		text-align: left;

		@media screen and (min-width: 580px) and (max-width: 992px) {
			text-align: center;
		}
	}

	#hero .text-wrapper-mid .btn-brothers {
		@media screen and (min-width: 991px) and (max-width: 1200px) and (min-height: 1100px) {
			margin-bottom: 80px;
		}
	}
}
</style>
